export default "__VITE_ASSET__Bcx44QT0__"